import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Service } from '@/features/services/types';
import styles from './ServiceCard.module.scss';

interface ServiceCardProps {
  service: Service;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const { t } = useTranslation('service');
  const isAvailable = service.status === 'available';

  return (
    <a
      href={isAvailable ? service.url : undefined}
      className={`${styles.card} ${isAvailable ? '' : styles.disabled}`}
      aria-disabled={!isAvailable}
    >
      <div className={styles.iconWrap}>
        <img src="/assets/icon-color.svg" alt="" className={styles.icon} />
      </div>
      <div className={styles.body}>
        <h3 className={styles.name}>{service.name}</h3>
        <p className={styles.description}>{service.description}</p>
      </div>
      <span className={styles.status}>
        {isAvailable ? t('open') : t('comingSoon')}
      </span>
    </a>
  );
};
